import Notifications from '@kyvg/vue3-notification'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('vue:setup', () => {
    nuxtApp.vueApp.use(Notifications, {})
  })
})
